import { action, computed, makeAutoObservable, observable } from 'mobx'

import type ExtendedMap from '@/models/ExtendedMap'

import type { PaymentStudent } from './PaymentStudent'

export class PaymentStudentColl {
  constructor(private paymentStudentMap: ExtendedMap<PaymentStudent['studentId'], PaymentStudent>) {
    makeAutoObservable<this, 'paymentStudentMap'>(this, {
      paymentStudentMap: observable,
      toArr: computed,
      isEmpty: computed,
      adds: action,
    })
  }

  get toArr() {
    return [...this.paymentStudentMap.values()]
  }

  get isEmpty() {
    return this.paymentStudentMap.isEmpty
  }

  adds(paymentStudentColl: PaymentStudentColl) {
    this.paymentStudentMap.adds(paymentStudentColl.paymentStudentMap.entries())
  }
}
